module.exports = __webpack_public_path__ + "media/images/bg-bd1abc66f9226752913602142d732960.jpeg";